import { Col, Row } from "@payping/web-components";
import React from "react";
import { useAsync } from "react-use";
import { getTotalTransactionCount } from "@payping/redux/actions";
import { useAppDispatch } from "@/utils/redux";
import styles from "../../../assets/scss/SummationTab.module.scss";
import Wizard from "../Wizard";
import AllTimesStatCard from "./AllTimesStatCard";
import BalanceCard from "./BalanceCard";
import NotifBlogCard from "./NotifBlogCard";
import TodayStatCard from "./TodayStatCard";

const FirstRow: React.FC = () => {
  const dispatch = useAppDispatch();
  const { value: totalTransactionCount } = useAsync(() => dispatch(getTotalTransactionCount()), []);
  return (
    <Row justify="space-between" gutter={[32, 16]}>
      <Col xs={24} md={12} xl={6} className={styles.col}>
        <NotifBlogCard />
      </Col>
      {typeof totalTransactionCount !== "undefined" && totalTransactionCount < 1 ? (
        <Col xs={24} md={24} xl={18} className={styles.col}>
          <Wizard />
        </Col>
      ) : (
        <>
          <Col xs={24} md={12} xl={6} className={styles.col}>
            <TodayStatCard />
          </Col>
          <Col xs={24} md={12} xl={6} className={styles.col}>
            <AllTimesStatCard />
          </Col>
          <Col xs={24} md={12} xl={6} className={styles.col}>
            <BalanceCard />
          </Col>
        </>
      )}
    </Row>
  );
};

export default FirstRow;
